import React, {useState, useEffect} from "react";
import Layout from "../Layout";
import {Typography, Spin, message} from "antd";

const {Title} = Typography;

function Leaderboard() {
    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(false);

    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        fetchLeaderboard();
    }, []);

    const fetchLeaderboard = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://api.edumonics.in/admin/class-leaderboard", {
                method: "GET",
                headers: {Authorization: `Bearer ${accessToken}`},
            });
            if (response.ok) {
                const data = await response.json();
                const sortedData = data.sort((a, b) => b.total_xp - a.total_xp); // Sort by XP
                setLeaderboard(sortedData);
            } else {
                message.error("Failed to fetch leaderboard.");
            }
        } catch (error) {
            console.error("Error fetching leaderboard:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout pageTitle="Class Leaderboard">
            <div className="container mx-auto px-6 py-12 bg-white text-gray-800">
                <Title level={2} className="text-center mb-8">Class Leaderboard</Title>
                {loading ? (
                    <div className="flex justify-center">
                        <Spin size="large"/>
                    </div>
                ) : (
                    <div className="flex flex-wrap justify-center gap-6">
                        {leaderboard.map((user, index) => (
                            <div
                                key={user.student_id}
                                className={`flex flex-col items-center rounded-lg p-6 shadow-lg ${
                                    index === 0 ? "border-4 border-yellow-500" : "bg-gray-100"
                                }`}
                                style={{
                                    width: "100%",
                                    maxWidth: "300px",
                                    textAlign: "center",
                                    transition: "transform 0.3s",
                                    transform: "translateY(0)",
                                    fontFamily: "Gotham, sans-serif",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                            >
                                <div className="text-xl font-bold mb-2">
                                    {index === 0 && <span className="text-yellow-500">🏆 Top Performer</span>}
                                    <div>{user.name}</div>
                                </div>
                                {/*<p className="text-sm text-gray-600 mb-4">{user.email || "Email not provided"}</p>*/}
                                <p className="text-2xl font-semibold text-yellow-500 mb-4">
                                    {user.total_xp} XP
                                </p>
                                <p className="text-sm mt-4">Rank: <strong>{index + 1}</strong></p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Layout>
    );
}

export default Leaderboard;
